import Vue from 'vue';

// eslint-disable-next-line no-unused-vars
Vue.directive('special-characters-validator', function (el, binding, vnode) {
    }
);

